export default __webpack_public_path__ + "static/media/not_pass.dd237411.png";